import { render, staticRenderFns } from "./recordVideo.vue?vue&type=template&id=aa576c84&scoped=true"
import script from "./recordVideo.vue?vue&type=script&lang=js"
export * from "./recordVideo.vue?vue&type=script&lang=js"
import style0 from "./recordVideo.vue?vue&type=style&index=0&id=aa576c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa576c84",
  null
  
)

export default component.exports